import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Route, RouteProps } from 'react-router-dom';
import { selectParentIsAuthenticated } from '../selectors';
import LoginRedirect from './loginRedirect';

// Defined at module scope on purpose. This guard used to be declared inside
// App's render(), which made it a brand-new component type on every App
// re-render, so React unmounted and remounted the whole routed subtree —
// that is what made the dashboard fetch itself twice (ENG double-load).
// Keep this, and every other route wrapper, out of a render body.
export interface PrivateRouteProps extends Omit<RouteProps, 'component'> {
  // React Router's own type for this prop. Most pages routed here are
  // legacy connect()-ed components whose inferred props do not match
  // RouteComponentProps, which is exactly why RouteProps allows both.
  component: NonNullable<RouteProps['component']>;
}

const PrivateRoute: FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const isAuthenticated = useSelector(selectParentIsAuthenticated);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <LoginRedirect />
      }
    />
  );
};

export default PrivateRoute;
